import { apiMipe } from '@/core/api/';

/**
 *
 * @param {*} properties = {
 * AcademicYearId,
 * CenterId,
 * RegionId,
 * DistrictId,
 * MunicipalityId,
 * Enum SchoolTypes: { UnSet, Institutions, Home, PublicSchool, PrivateSchool ,CareCenter }
 * }
 */
export const getMunicipalities = async (params) => {
  try {
    const { data } = await apiMipe.get('api/location/municipalities', {
      params,
    });
    return data;
  } catch {
    return null;
  }
};

export const getStates = () => apiMipe.get(`api/location/states`);
export const getCountries = () => apiMipe.get(`api/location/countries`);

export const getRegions = async (params) => {
  try {
    const { data } = await apiMipe.get('api/location/regions', {
      params,
    });
    return data;
  } catch {
    return null;
  }
};

export const getDistricts = async (params) => {
  try {
    const { data } = await apiMipe.get('api/location/districts', {
      params,
    });
    return data;
  } catch {
    return null;
  }
};

export const getSchools = async (params) => {
  try {
    const { data } = await apiMipe.get('api/location/schools', {
      params,
    });
    return data;
  } catch {
    return null;
  }
};

export const getSchoolsAddress = async ({ LocationSchoolId }) => {
  try {
    const { data } = await apiMipe.get('api/schools/getlocationschooladdress', {
      params: { LocationSchoolId },
    });
    return data;
  } catch {
    return null;
  }
};

export const getCenterAddress = async ({ CenterId }) => {
  try {
    const { data } = await apiMipe.get('api/location/getcenteraddress', {
      params: { CenterId },
    });
    return data;
  } catch {
    return null;
  }
};

export const getCenters = async (params) => {
  try {
    const { data } = await apiMipe.get('api/location/centers', {
      params,
    });
    return data;
  } catch {
    return null;
  }
};

export const getAvailableLocationHomeMunicipalities = async ({
  fiscalYearId,
  companyId,
}) => {
  try {
    const { data } = await apiMipe.get(
      'api/location/availablelocationhomemunicipalities',
      {
        params: { fiscalYearId: fiscalYearId, companyId: companyId },
      }
    );
    return data;
  } catch {
    return [];
  }
};
